import { render, staticRenderFns } from "./VerComprobante.vue?vue&type=template&id=6216baa2"
import script from "./VerComprobante.vue?vue&type=script&lang=js"
export * from "./VerComprobante.vue?vue&type=script&lang=js"
import style0 from "./VerComprobante.vue?vue&type=style&index=0&id=6216baa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports